export enum SortDirection {
    ASC     = 'asc',    // lower case for lodash supprot
    DESC    = 'desc'
}